import { DataTableColumnHeader } from "@/components/ui";
import type { MatterIntakeTemplateResponse } from "@/lib/types";
import { formatDate, formatLocalOrIntlPhoneNumber } from "@/lib/utils/format";
import { type ColumnDef } from "@tanstack/react-table";

export const matterIntakeResponsesTableColumns: ColumnDef<MatterIntakeTemplateResponse>[] =
  [
    {
      accessorFn: (row) => row.question?.label ?? row.questionId,
      id: "Question",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
    },
    {
      accessorFn: (row) => row.answer,
      id: "Response",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => {
        let response = row.original.answer;
        const questionType = row.original.question?.type;
        if (!response) return "-";
        if (questionType === "Date") {
          response = formatDate(response);
        }
        if (questionType === "Checkbox") {
          response = response === "true" ? "Yes" : "No";
        }
        if (questionType === "Phone Number") {
          response = formatLocalOrIntlPhoneNumber({ number: response });
        }
        return (
          <div className="max-w-md truncate" title={response}>
            {response}
          </div>
        );
      },
    },
  ];
